import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import classNames from 'classnames';

import Error from '@components/form/error';

export default function Textarea({ label, ...props }) {
  const [field, meta] = useField(props);

  const classes = useMemo(() => (
    classNames(
      'input__wrapper',
      { error: meta.touched && !!meta.error },
    )
  ), [field, meta]);

  return (
    <div className={classes}>
      <label>
        <span className='input__wrapper__label'>{label}</span>
        <div className='input__wrapper__input'>
          <textarea {...field} {...props} />
        </div>
      </label>
      <Error name={field.name} />
    </div>
  );
}

Textarea.defaultProps = {
  label: '',
};

Textarea.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
};
